import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
export var smallVerticalSpacing = 15;
export var bulletSize = 10;
export var commonGutterStyle = designContext => ({
  width: 2,
  position: 'absolute',
  backgroundColor: designContext.get('timeline/gutter-background-color').toString(),
  height: '100%',
  top: 0,
  left: 4
});

// Overriding Title.Information
export var titleInformationOverride = (designContext, small) => _objectSpread(_objectSpread({
  paddingBottom: 4,
  paddingTop: 1
}, designContext.get('timeline/title-text-style', {
  size: small ? 'small' : 'default'
}).styles()), {}, {
  color: designContext.get('timeline/title-color').toString(),
  textRendering: 'geometricPrecision',
  WebkitFontSmoothing: 'antialiased',
  whiteSpace: 'pre-line',
  // this matches the correctFootprint
  marginBottom: -10,
  marginTop: -5
});
//# sourceMappingURL=style.js.map